// Curated list of maps available to the offline demo. These files ship in the
// client bundle under static/assets/maps/ (copied to ./assets/maps/ at build).
// Each must define at least two stations so the local player can spawn and so a
// station can be assigned to each team.
export const OFFLINE_MAPS = [
  "Duff Gardens",
  "Cyberia",
  "Bad Lands",
  "Iron Helix",
  "Jigsaw",
  "New Minglewood",
  "Antarctica",
  "Gristle",
];

export function pickRandomOfflineMap(): string {
  return OFFLINE_MAPS[Math.floor(Math.random() * OFFLINE_MAPS.length)];
}
